export default __webpack_public_path__ + "static/seo-a979c6da35831ba3274fa13f21fc8c67.jpg";